import { emitFreshViewEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex) => {
    return {
        ...cinemaTracking,
        position: Number(featureIndex),
        labels: {
            promo_RecoAddToCartButton: ["visible"],
        },
    };
};

const track = (cinemaTracking, featureIndex) => {
    const event = [buildCinema(cinemaTracking, featureIndex)];

    emitFreshViewEvent(event);
};

export default track;
